import { LegalLayout, Section, Li, B } from "../components/LegalLayout";

const UPDATED = "June 1, 2026";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund Policy" updated={UPDATED}>
      <p className="text-slate-300">
        We want you to be happy with PNR Decode. This Refund Policy explains when you may be eligible for a refund
        on your subscription and how to request one.
      </p>

      <Section heading="1. Eligibility for Refunds">
        <ul className="space-y-2">
          <Li>New subscribers may request a full refund within <b>14 days</b> of their first paid charge if they are
            not satisfied with the service.</Li>
          <Li>Refunds may be considered where a documented technical fault on our side prevented you from using the
            service and we were unable to resolve it.</Li>
          <Li>Duplicate or accidental charges will be refunded in full.</Li>
        </ul>
      </Section>

      <Section heading="2. Refund Timeframes">
        <p>
          Approved refunds are issued to your original payment method. Please allow <b>5–10 business days</b> for the
          amount to appear, depending on your bank or card provider.
        </p>
      </Section>

      <Section heading="3. How to Request a Refund">
        <ul className="space-y-2">
          <Li>Email <B>support@pnrdecode.com</B> from the address associated with your account.</Li>
          <Li>Include your account email, the plan you subscribed to, and the reason for the request.</Li>
          <Li>We will acknowledge your request within one business day and let you know the outcome.</Li>
        </ul>
      </Section>

      <Section heading="4. Non-Refundable Items">
        <ul className="space-y-2">
          <Li>Renewal charges after the initial 14-day window, unless required by law.</Li>
          <Li>Partial or unused portions of a billing period after the refund window has passed.</Li>
          <Li>Fees arising from misuse of the service or violations of our Terms of Use.</Li>
        </ul>
      </Section>

      <Section heading="5. Cancellations">
        <p>
          You can cancel your subscription at any time from your dashboard. Cancellation stops future billing; you
          keep access until the end of your current paid period. Cancelling does not automatically trigger a refund
          unless you qualify under the sections above.
        </p>
      </Section>

      <Section heading="6. Contact">
        <p>Questions about refunds? Reach us at <B>support@pnrdecode.com</B>.</p>
      </Section>
    </LegalLayout>
  );
}
